import { Injectable, ChangeDetectorRef, ApplicationRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  public loader:BehaviorSubject<any> = new BehaviorSubject(null);
  constructor() { }
  setValue(value:boolean) {
    this.loader.next(value);
  }


  getValue(): Observable<any> {
    return this.loader.asObservable();
  }
}
